export function formatCount(n) {
  return typeof n === 'number' ? n.toLocaleString() : '—';
}

export function formatCtr(n) {
  return typeof n === 'number' ? `${(n * 100).toFixed(1)}%` : '—';
}

export function formatPosition(n) {
  return typeof n === 'number' ? n.toFixed(1) : '—';
}

export function filterQueryRows(rows, { q = '', minImpressions = '', hasClicks = 'any', positionMax = '' } = {}) {
  const needle = String(q || '').trim().toLowerCase();
  const minImp = minImpressions === '' || minImpressions == null ? null : Number(minImpressions);
  const maxPos = positionMax === '' || positionMax == null ? null : Number(positionMax);
  return (rows || []).filter((row) => {
    if (needle && !(row.query || '').toLowerCase().includes(needle)) return false;
    if (minImp != null && !Number.isNaN(minImp) && (row.impressions == null || row.impressions < minImp)) return false;
    if (hasClicks === 'yes' && !(row.clicks > 0)) return false;
    if (hasClicks === 'none' && row.clicks !== 0) return false;
    if (maxPos != null && !Number.isNaN(maxPos) && (row.position == null || row.position > maxPos)) return false;
    return true;
  });
}

export function sortQueryRows(rows, key = 'impressions', dir = 'desc') {
  const mul = dir === 'asc' ? 1 : -1;
  return [...(rows || [])].sort((a, b) => {
    if (key === 'query') return mul * String(a.query || '').localeCompare(String(b.query || ''));
    const av = a[key];
    const bv = b[key];
    if (av == null && bv == null) return String(a.query || '').localeCompare(String(b.query || ''));
    if (av == null) return 1;
    if (bv == null) return -1;
    if (av === bv) return String(a.query || '').localeCompare(String(b.query || ''));
    return mul * (av - bv);
  });
}
